import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Subjects from "./Subjects";
import LanguageManager from "./LanguageManager";
import SkillsManager from "./SkillsManager";
import Portfolio from "./Portfolio";
import Experience from "./Experience";
import Socials from "./Socials";
import Header from "../../../components/header";
import Footer from "../../../components/footer";
import bgImage from "../../../assets/backgroundvector.jpg";
import AdminImg from "../../../assets/admin.png";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const TeacherProfilePage = () => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [activeTab, setActiveTab] = useState("experience");
  console.log("The profile is:",profile?.user)
  const [experienceYearsList, setExperienceYearsList] = useState([]);
  const [socials, setSocials] = useState({
    facebook: "",
    insta: "",
    linkedin: "",
    researchgate: "",
    ieee: "",
  });

  const [subjectsList, setSubjectsList] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [skillList, setSkillList] = useState([]);
  const [pdfFiles, setPdfFiles] = useState([]);
  const [videoIntro, setVideoIntro] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch(`${BASE_URL}/user/profile/create-profile/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });
        const data = await res.json();
        if (res.ok) {
          setProfile(data.data);
        } else {
          console.error("Profile fetch failed", data);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoadingProfile(false);
      }
    };

    fetchProfile();
  }, []);

  const handleSubmitTeacherInfo = async () => {
    try {
      setSubmitting(true);
       if(!profile?.user)
       {
         setError('User id required')
         return;
       }
      if (
        !experienceYearsList.length ||
        !subjectsList.length ||
        !languages.length ||
        !skillList.length
      ) {
        setError("Please fill all required fields.");
        setSubmitting(false);
        return;
      }

      if (!pdfFiles.length) {
        setError("Please upload at least one portfolio file.");
        setSubmitting(false);
        return;
      }

      setError("");
      const formData = new FormData();

      formData.append("experiences", JSON.stringify(experienceYearsList));
      formData.append("subjects", JSON.stringify(subjectsList));
      formData.append("languages", JSON.stringify(languages));
      formData.append("skills", JSON.stringify(skillList));
      formData.append("socials", JSON.stringify(socials));
      formData.append("user",profile?.user)

      pdfFiles.forEach((file) => formData.append("portfolios", file));
      videoIntro.forEach((file) => formData.append("videos", file));

      const res = await fetch(`${BASE_URL}/teacher/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
        body: formData,
      });

      const data = await res.json();
      console.log("Server response:", data);

      if (res.ok) {
        alert("You are now a teacher!");
        navigate("/teacher");
      } else {
        alert(data.msg || data.detail || "Failed to submit teacher info.");
      }
    } catch (err) {
      console.error("Error submitting teacher info:", err);
      alert("An error occurred while submitting.");
    } finally {
      setSubmitting(false);
    }
  };

  if (loadingProfile) {
    return (
      <div className="min-h-screen bg-[#F9F7F4] font-sans">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading profile...</p>
        </div>
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="min-h-screen bg-[#F9F7F4] font-sans">
        <div className="error-container">
          <p>No profile found</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      <div className="relative max-w-full">
        <div
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="w-full max-w-[1024px] pt-5 pb-0 mx-auto mt-0 flex flex-col relative rounded-t-[10px] px-3 md:px-0">
            {/* Cover Photo */}
            <div className="w-full h-[180px] md:h-[220px] lg:h-[250px] mb-[-85px] sm:mb-[-95px] lg:mb-[-105px] rounded-xl overflow-hidden relative">
              <img
                src={profile.cover_image || AdminImg}
                alt="User profile"
                className="w-full h-full object-cover object-center"
              />
            </div>

            {/* Main white profile section */}
            <div className="w-full max-w-[1024px] px-0 pb-0 mx-auto mt-0 flex flex-col relative rounded-[10px_10px_0px_0px]">
              {/* Profile Picture */}
              <div className="flex relative pl-4 sm:pl-6 w-full max-w-fit mb-[-55px] sm:mb-[-65px] z-10">
                <div className="relative">
                  {profile?.profile_picture ? (
                    <img
                      src={profile.profile_picture}
                      alt="User profile"
                      className="w-[100px] h-[100px] sm:w-[120px] sm:h-[120px] md:w-[130px] md:h-[130px] rounded-full object-cover border-4 border-white shadow-lg"
                    />
                  ) : (
                    <div className="w-[100px] h-[100px] sm:w-[120px] sm:h-[120px] md:w-[130px] md:h-[130px] rounded-full bg-[#e8f0f7] border-4 border-white shadow-lg flex items-center justify-center">
                      <svg
                        className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 text-[#0f6abf]"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        />
                      </svg>
                    </div>
                  )}
                  <div className="absolute -bottom-0 -right-1 w-5 h-5 sm:w-6 sm:h-6 rounded-full border-2 border-white bg-green-500" />
                </div>
              </div>

              {/* Content */}
              <div className="flex flex-col w-full p-3 sm:p-4 pl-4 sm:pl-7 gap-3 sm:gap-4 rounded-t-[10px] bg-white text-gray-900">
                <div className="pl-[110px] sm:pl-[135px] md:pl-[150px]">
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between w-full mb-3 gap-3 sm:gap-0">
                    <div className="w-full">
                      <h2 className="text-lg sm:text-xl font-semibold text-gray-900">
                        {profile.name}
                      </h2>

                      {profile.research_areas && (
                        <div className="flex items-center gap-2 sm:gap-3 mt-2">
                          <div className="flex flex-wrap gap-1 sm:gap-2">
                            {profile.research_areas
                              .split(",")
                              .slice(0, 3)
                              .map((area, index) => (
                                <span
                                  key={index}
                                  className="text-[10px] xs:text-xs px-2 py-0.5 sm:px-3 sm:py-1 bg-[#e8f0f7] text-[#0f6abf] rounded-md sm:rounded-lg font-medium"
                                >
                                  {area.trim()}
                                </span>
                              ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Blue details card */}
                <div className="w-full flex justify-center">
                  <div className="bg-[#dfefff] rounded-xl sm:rounded-2xl p-4 sm:p-5 lg:p-6 w-full space-y-3 sm:space-y-4">
                    {profile.degree && (
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                        <p className="text-sm sm:text-base font-semibold text-[#0f6abf]">
                          {profile.degree}
                        </p>
                      </div>
                    )}

                    {profile.primary_affiliation && (
                      <div className="pt-2 sm:pt-3 border-t border-gray-200">
                        <div className="flex items-center gap-2 mb-1 sm:mb-2">
                          <svg
                            className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-gray-500"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                            />
                          </svg>
                          <p className="text-xs sm:text-sm font-medium text-gray-900">
                            {profile.primary_affiliation}
                          </p>
                        </div>
                      </div>
                    )}

                    {profile.current_activity && (
                      <div className="flex items-start gap-2">
                        <svg
                          className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-gray-500 mt-0.5 flex-shrink-0"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        <p className="text-xs sm:text-sm text-gray-700 leading-relaxed">
                          {profile.current_activity}
                        </p>
                      </div>
                    )}

                    {profile.bio && (
                      <div className="w-full pt-3 sm:pt-4 mt-3 sm:mt-4 border-t border-gray-200">
                        <div className="flex items-center gap-2 mb-2 sm:mb-3">
                          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                          <h4 className="text-xs sm:text-sm font-semibold text-gray-900">
                            About
                          </h4>
                        </div>
                        <p className="text-sm sm:text-base text-gray-800 leading-relaxed">
                          {profile.bio}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Teacher info heading - same style as profile section heading */}
                <div className="mt-8">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                      <svg
                        className="w-5 h-5 text-[#0f6abf]"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                        />
                      </svg>
                    </div>
                    <div>
                      <h1 className="text-lg font-semibold text-gray-900">
                        Fill Necessary Information to Become a Teacher
                      </h1>
                      <p className="text-sm text-gray-500">
                        Completing these details will help students understand
                        your expertise and find you easily.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Tabs section - placed right under white area like profile */}
            <div className="w-full max-w-[1024px] flex justify-between gap-2 p-2 bg-white rounded-b-xl mx-auto border-t border-gray-100">
              <div className="flex gap-2 overflow-x-auto scrollbar-hidden w-full">
                {[
                  "experience",
                  "subjects",
                  "languages",
                  "skills",
                  "socials",
                  "portfolio",
                  "video",
                ].map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setActiveTab(tab)}
                    className={`flex-shrink-0 max-w-[130px] h-[40px] px-6 py-3 text-sm font-medium rounded-[30px] border transition-all duration-200 flex items-center justify-center ${
                      activeTab === tab
                        ? "bg-[#0f6abf] border-[#0f6abf] text-white"
                        : "bg-white border-gray-200 text-gray-700 hover:border-[#0f6abf]"
                    }`}
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Content area */}
        <div className="bg-gray-50 min-h-[70vh]">
          <div className="w-full max-w-6xl mx-auto py-8 px-3 md:px-4">
            <div className="w-full max-w-6xl mx-auto bg-white rounded-2xl border border-gray-200 p-6">
              {activeTab === "experience" && (
                <Experience
                  experienceYearsList={experienceYearsList}
                  setExperienceYearsList={setExperienceYearsList}
                />
              )}

              {activeTab === "subjects" && (
                <Subjects
                  subjectsList={subjectsList}
                  setSubjectsList={setSubjectsList}
                />
              )}

              {activeTab === "languages" && (
                <LanguageManager
                  languages={languages}
                  setLanguages={setLanguages}
                />
              )}

              {activeTab === "skills" && (
                <SkillsManager
                  skillList={skillList}
                  setSkillList={setSkillList}
                />
              )}

              {activeTab === "portfolio" && (
                <Portfolio pdfFiles={pdfFiles} setPdfFiles={setPdfFiles} />
              )}

              {activeTab === "socials" && (
                <Socials socials={socials} setSocials={setSocials} />
              )}

              {activeTab === "video" && (
                <div className="space-y-6">
                  <div className="flex items-center gap-2">
                    <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                    <label className="text-sm font-semibold text-gray-700">
                      Video Introduction
                    </label>
                    <span className="text-xs text-gray-500">
                      (Optional, multiple allowed)
                    </span>
                  </div>

                  <div
                    className="border-2 border-dashed border-gray-300 bg-gray-50 rounded-2xl p-8 text-center hover:border-[#0f6abf] hover:bg-[#e8f0f7]/10 transition-colors cursor-pointer"
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      e.preventDefault();
                      const files = Array.from(e.dataTransfer.files).filter(
                        (f) => f.type.startsWith("video/")
                      );
                      setVideoIntro([...videoIntro, ...files]);
                    }}
                  >
                    <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm">
                      <svg
                        className="w-8 h-8 text-[#0f6abf]"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                    <p className="text-gray-700 font-medium mb-1">
                      Drag & drop videos here
                    </p>
                    <p className="text-sm text-gray-500 mb-4">
                      or click to browse
                    </p>

                    <input
                      type="file"
                      accept="video/*"
                      multiple
                      className="hidden"
                      id="video-upload"
                      onChange={(e) => {
                        const files = Array.from(e.target.files).filter((f) =>
                          f.type.startsWith("video/")
                        );
                        setVideoIntro([...videoIntro, ...files]);
                      }}
                    />

                    <label
                      htmlFor="video-upload"
                      className="inline-block px-4 py-2 bg-white border border-gray-300 text-gray-700 text-sm font-medium rounded-xl hover:bg-gray-50 hover:border-gray-400 transition-colors cursor-pointer"
                    >
                      Choose Videos
                    </label>
                  </div>

                  {videoIntro.length > 0 && (
                    <div className="space-y-4">
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                        <h4 className="text-sm font-semibold text-gray-700">
                          Uploaded Videos
                        </h4>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {videoIntro.map((file, index) => (
                          <div key={index} className="relative group">
                            <video
                              className="w-full h-[200px] rounded-xl object-cover border border-gray-200"
                              controls
                              src={
                                file instanceof File
                                  ? URL.createObjectURL(file)
                                  : file
                              }
                            />
                            <button
                              onClick={() =>
                                setVideoIntro(
                                  videoIntro.filter((_, i) => i !== index)
                                )
                              }
                              className="absolute top-2 right-2 w-8 h-8 bg-red-500 rounded-lg flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-600"
                            >
                              <svg
                                className="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M6 18L18 6M6 6l12 12"
                                />
                              </svg>
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  <div className="flex flex-col items-center pt-8 border-t border-gray-200">
                    <button
                      type="button"
                      onClick={handleSubmitTeacherInfo}
                      disabled={submitting}
                      className="px-8 py-3 bg-[#0f6abf] text-white font-semibold rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                    >
                      {submitting ? (
                        <>
                          <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                          Submitting...
                        </>
                      ) : (
                        "Submit Teacher Information"
                      )}
                    </button>

                    {error && (
                      <div className="flex items-center gap-2 mt-4 text-red-500 text-sm">
                        <svg
                          className="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        {error}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TeacherProfilePage;